// @flow

import React, { useEffect } from 'react';
import Helmet from 'react-helmet';

import Body from '../../components/Body';
import PageHeader from '../../components/PageHeader';

const NotFound = () => {
  useEffect(() => {
    (window.dataLayer || []).push({
      event: 'page_view_business',
      page_name: 'notFound',
    });
  }, []);

  return (
    <Body>
      <Helmet title="Page not found - 404" />
      <PageHeader title="Not found" />
    </Body>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/routes/NotFound/index.js